import { Group, useMantineTheme } from '@mantine/core';
import { Button, Icon, Text } from '@repo/foundations';
import { useNavigate } from 'react-router';
import { useAuthUser } from '../../api/hooks/authUser/useAuthUser';
import { NavBarWrapper } from '../SecodaAppShell/SecodaNavBar';
import { useImpersonationBanner } from './useImpersonationBanner';

export function ImpersonationBanner() {
	const { user: currentUser } = useAuthUser();
	const theme = useMantineTheme();
	const navigate = useNavigate();

	const { showImpersonationBanner } = useImpersonationBanner();

	if (!showImpersonationBanner) {
		return null;
	}

	return (
		<NavBarWrapper bg={theme.other.getColor('surface/caution/default')}>
			<Group position="apart" w="100%">
				<Group spacing="xs">
					<Icon name="infoCircle" />
					<Text weight="bold" size="sm">
						Logged in as {currentUser?.display_name}
					</Text>
				</Group>
				<Button
					variant="default"
					onClick={() => navigate('/auth/logout/?redirect=/settings/members')}
				>
					Stop impersonation
				</Button>
			</Group>
		</NavBarWrapper>
	);
}
